import { AccordionContent } from '@radix-ui/react-accordion';
import { PropsWithChildren } from 'react';

const SectionAccordionContent = ({
    children,
    isOpen,
    keepMounted,
}: PropsWithChildren<{ isOpen?: boolean; keepMounted?: boolean }>) => {
    return (
        <AccordionContent
            className="tw-flex tw-flex-col tw-gap-10 tw-p-10 data-[state=closed]:tw-hidden"
            forceMount={keepMounted ? true : undefined }
        >
            {isOpen || keepMounted ? children : null}
        </AccordionContent>
    );
};

SectionAccordionContent.DisplayName = 'SectionAccordionContent';

export { SectionAccordionContent };
